var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
var _EM = _interopRequireDefault(require("./EM"));
var _Strong = _interopRequireDefault(require("./Strong"));
var _Link = _interopRequireDefault(require("./Link"));
var _Heading = _interopRequireDefault(require("./Heading"));
var _List = _interopRequireDefault(require("./List"));
var _Small = _interopRequireDefault(require("./Small"));
var _Mark = _interopRequireDefault(require("./Mark"));
var _default = exports["default"] = {
  paragraph: _Paragraph["default"],
  em: _EM["default"],
  strong: _Strong["default"],
  link: _Link["default"],
  heading: _Heading["default"],
  list: _List["default"],
  small: _Small["default"],
  mark: _Mark["default"]
};